module.exports = from;

var base64 = require('base64-js');

var decoders = {
  hex: from_hex,
  utf8: from_utf,
  base64: from_base64
};

function from(source, encoding) {
  if (Array.isArray(source)) {
    return new Uint8Array(source);
  }

  return decoders[encoding || 'utf8'](source);
}

function from_hex(str) {
  var size = str.length / 2,
      buf = new Uint8Array(size),
      character = '';

  for (var i = 0, len = str.length; i < len; ++i) {
    character += str.charAt(i);

    if (i > 0 && i % 2 === 1) {
      buf[i >>> 1] = parseInt(character, 16);
      character = '';
    }
  }

  return buf;
}

function from_utf(str) {
  var bytes = [],
      tmp,
      ch;

  for (var i = 0, len = str.length; i < len; ++i) {
    ch = str.charCodeAt(i);

    if (ch & 0x80) {
      tmp = encodeURIComponent(str.charAt(i)).substr(1).split('%');

      for (var j = 0, jlen = tmp.length; j < jlen; ++j) {
        bytes[bytes.length] = parseInt(tmp[j], 16);
      }
    } else {
      bytes[bytes.length] = ch;
    }
  }

  return new Uint8Array(bytes);
}

function from_base64(str) {
  return new Uint8Array(base64.toByteArray(str));
}